import {GetProfessionalParams} from 'domain/usecases';
import {makeGetRefundProfessionals} from 'main/factories/usecases';
import {parseRefundProviders} from '../utils/parseRefundProviders';

export const getRefundProfessional = async ({
	document,
	limit = 5,
	page = 1,
	state,
	councils,
	signal,
	...params
}: GetProfessionalParams) => {
	const data = await makeGetRefundProfessionals().get({
		'council-acronym': params['council-acronym'],
		'council-number': params['council-number'],
		'modality-code': params['modality-code'],
		document,
		page,
		state,
		limit,
		signal,
	});

	if (!data) {
		return {
			content: {
				providers: [],
				total: 0,
				totalPerPage: 0,
			},
		};
	}

	const parsedProviders = parseRefundProviders({providers: data.content.providers, councils});

	return {...data, content: {...data.content, providers: parsedProviders}};
};
